// extracted by mini-css-extract-plugin
export default {"container":"UserPage_container__Ql5Mj","sectionTitle":"UserPage_sectionTitle__P8Yb1","slideIn":"UserPage_slideIn__zdcmB","footerMenuContainer":"UserPage_footerMenuContainer__fXEZZ"};